import React, {Fragment, useEffect, useState} from "react";
import {Outlet} from "react-router-dom";
import {useStore} from "modules/hooks";
import {SecretPage} from "components/SecretPage";
import {SecretPageUtils} from "modules/utils/secret_page";

export const Layout: React.FC = () => {
	const {modal} = useStore();
	const [underSecret, setUnderSecret] = useState(SecretPageUtils.isEnabled());

	useEffect(() => {
		const eventHandler = () => {
			modal.setError("modal.error.no_connection");
		};

		window.addEventListener("offline", eventHandler);

		return () => {
			window.removeEventListener("offline", eventHandler);
		};
	}, [modal]);

	const onDisableSecret = () => {
		SecretPageUtils.disable();
		setUnderSecret(false);
	};

	if (underSecret) {
		return <SecretPage onPass={onDisableSecret} />;
	}

	return (
		<Fragment>
			<Outlet />
		</Fragment>
	);
};
